export const normalizeErrorCode = (errorCode: string) => {
  if (/^[A-Z0-9_]+$/.test(errorCode)) {
    return errorCode;
  }

  return errorCode
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2') // insert _ between lower and upper
    .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2') // handle sequences like "HTMLParser"
    .toUpperCase();
};
